<template>
  <Info>
    {{ errorText }}
  </Info>
</template>

<script>
import lodashDebounce from "lodash/debounce";
import { logout } from "@/common/authenticate";

export default {
  name: "UrlError",
  components: {
    Info: () => import("@/components/auth/Info"),
  },
  props: {
    message: { type: String, required: true },
  },
  data: () => {
    return {
      errorText: null,
    };
  },
  mounted() {
    this.errorText = this.message;

    // go to login screen after 10 seconds
    lodashDebounce(async () => {
      await logout();
    }, 10000)();
  },
};
</script>

<style scoped></style>
